import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import type { AuditLog } from '@repo/api-gw-sdk';
import type { Row } from '@tanstack/react-table';
import { useState } from 'react';
import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
import { MainDialog } from '@/components/dialogs/mainDialog';
import { JsonViewer } from '@/components/shared/jsonViewer';
export const AuditLogOperationCell = t0 => {
  const $ = _c(10);
  const {
    row
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClick = t1;
  let t2;
  if ($[1] !== row.original.operationName) {
    t2 = <Typography variant="subtitle1" className="underline hover:cursor-pointer hover:text-(--mui-palette-text-secondary)" onClick={handleClick}>{row.original.operationName}</Typography>;
    $[1] = row.original.operationName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isOpen || $[5] !== row.original) {
    t4 = <AuditLogJsonViewer data={row.original} isOpen={isOpen} onClose={t3} />;
    $[4] = isOpen;
    $[5] = row.original;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
const AuditLogJsonViewer = t0 => {
  const $ = _c(20);
  const {
    data,
    isOpen,
    onClose
  } = t0;
  const t1 = `Audit log parameters - ${data.operationName}`;
  let t2;
  if ($[0] !== onClose || $[1] !== t1) {
    t2 = {
      title: t1,
      onClose
    };
    $[0] = onClose;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClose) {
    t3 = {
      text: "Close",
      onClick: onClose,
      "data-testid": "close-audit-log-json-viewer"
    };
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data) {
    t4 = JSON.stringify(data);
    $[5] = data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <CopyToClipboardButton textToCopy={t4} buttonLabel="Copy" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = {
      primaryButton: t3,
      children: t5
    };
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      minHeight: "350px",
      maxHeight: "80%",
      overflow: "auto",
      fontFamily: "monospace",
      whiteSpace: "pre-wrap",
      "& *": {
        backgroundColor: "transparent !important"
      },
      "& ul > div": {
        paddingLeft: "28px"
      },
      "& [role=\"treeitem\"]": {
        lineHeight: "20px"
      },
      "& [role=\"button\"]": {
        marginLeft: "-14px"
      }
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== data) {
    t8 = <Box className="px-[40px]" sx={t7}><JsonViewer data={data} /></Box>;
    $[13] = data;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isOpen || $[16] !== t2 || $[17] !== t6 || $[18] !== t8) {
    t9 = <MainDialog isOpen={isOpen} isLoading={false} header={t2} footer={t6}>{t8}</MainDialog>;
    $[15] = isOpen;
    $[16] = t2;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};